import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Conservative, single owner of route-level scroll: every route change (incl. Back/Forward) starts at top.
 * Hash targets (e.g. /#contact) and in-page anchor navigation are left to the page's own anchor logic.
 */
export default function ScrollManager() {
  const { key, hash, state } = useLocation();

  useLayoutEffect(() => {
    if ('scrollRestoration' in window.history) window.history.scrollRestoration = 'manual';
    if ((state as { inPage?: boolean } | null)?.inPage) return;
    if (hash) return;
    window.scrollTo(0, 0);
  }, [key, hash, state]);

  return null;
}